import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Hero } from '../components/Hero';
import { GuideCard } from '../components/GuideCard';
import { hubRoutes, hubs, weekendEvents } from '../data/site';
import { featuredGuide, guides } from '../data/guides';
import { editImage, familyEdit, featuredBusiness } from '../data/features';
export function Home() {
  return <main id="main" data-id="element-807" data-mp="1ziqqpcashcgg">
      <Hero data-id="element-808" data-mp="1zjidpyqbm1v4" />
      <Hubs data-id="element-809" data-mp="1zjs4vpn3qf2e" />
      <Weekend data-id="element-810" data-mp="1zkaahcvnm5mz" />
      <StartHere data-id="element-811" data-mp="24gsci4zlnpvm" />
      <Spotlight data-id="element-812" data-mp="24g8teky7qvg0" />
      <Edit data-id="element-813" data-mp="24htocbofwgee" />
      <Newsletter data-id="element-814" data-mp="24hk7bdldhjku" />
    </main>;
}
function SectionHead({
  label,
  title,
  action,
  className = ''
}: {
  label: string;
  title: string;
  action?: {
    label: string;
    to: string;
  };
  className?: string;
}) {
  return <div className={`flex flex-wrap items-end justify-between gap-6 ${className}`} data-id="element-815" data-mp="2dfm57k9t7w3w">
      <div data-id="element-816" data-mp="3kv0nr3ex6cry">
        <p className="label text-olive" data-id="element-817" data-mp="3kxd276lgy509">{label}</p>
        <h2 className="mt-5 max-w-2xl font-display text-[42px] font-300 leading-[1.02] text-ink sm:text-[54px]" data-id="element-818" data-mp="3ow403fxrdqof">
          {title}
        </h2>
      </div>
      {action && <Link to={action.to} className="label group inline-flex items-center gap-2 border-b border-line pb-2 text-ink transition-colors duration-150 ease-soft hover:border-olive" data-id="element-819" data-mp="2vxyd6sglaehh">
          {action.label}
          <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-200 ease-soft group-hover:translate-x-1" aria-hidden="true" data-id="element-820" data-mp="2mw8jffz8j3gj" />
        </Link>}
    </div>;
}
const hubSwatches = ['bg-peach', 'bg-opal', 'bg-olive', 'bg-foam', 'bg-rose', 'bg-creme', 'bg-opal', 'bg-foam'];
function Hubs() {
  return <section aria-labelledby="hubs-h" className="border-t border-line bg-white" data-id="element-821" data-mp="239j7wxn9fajc">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-822" data-mp="1z7ftc05anptu">
        <h2 id="hubs-h" className="label text-muted" data-id="element-823" data-mp="1z9iiyj2jbgy1">
          Everything on the site, in eight places
        </h2>
        <ul className="mt-14 grid gap-x-14 gap-y-14 sm:grid-cols-2 lg:grid-cols-4" data-id="element-824" data-mp="1kkqm1c4sw8cw">
          {hubs.map((hub, i) => <li key={hub.path} className="group relative" data-id="element-825" data-mp="1omu1scyi5z3z" data-mpi={i}>
              <span className={`block h-2 w-14 ${hubSwatches[i]}`} aria-hidden="true" data-id="element-826" data-mp="1ok7umefixlma" />
              <h3 className="mt-6 font-display text-[27px] font-300 leading-tight text-ink" data-id="element-827" data-mp="1fl49l4wsqw55">
                <Link to={hubRoutes[hub.title] ?? '/things-to-do'} className="decoration-olive decoration-1 underline-offset-[7px] after:absolute after:inset-0 after:content-[''] group-hover:underline" data-id="element-828" data-mp="23bgrn8lra99g">
                  {hub.title}
                </Link>
              </h3>
              <p className="mt-3 text-[14px] leading-[1.75] text-muted" data-id="element-829" data-mp="1yjgkav3cwe2u">
                {hub.blurb}
              </p>
              <p className="label mt-5 text-muted/80" data-id="element-830" data-mp="2m8hykyyvejg1">{hub.count}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}
function Weekend() {
  return <section id="weekend" aria-labelledby="weekend-h" className="bg-paper" data-id="element-831" data-mp="fl0r7r2oeuue">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-832" data-mp="amz856592vix">
        <div id="weekend-h" data-id="element-833" data-mp="akmrqxf54t7z">
          <SectionHead label="Updated every Thursday" title="What’s on this weekend" action={{
          label: 'Full calendar',
          to: '/events'
        }} data-id="element-834" data-mp="oenknajevm0f" />
        </div>
        <ul className="mt-14 border-t border-line" data-id="element-835" data-mp="3ss2ltf9a8fuy">
          {weekendEvents.map(e => <li key={e.id} data-id="element-836" data-mp="3ntiuezbx6bv7">
              <Link to="/events" className="group grid grid-cols-1 items-baseline gap-y-2 border-b border-line py-7 transition-colors duration-150 ease-soft hover:bg-white sm:grid-cols-[92px_1fr_auto] sm:gap-x-8" data-id="element-837" data-mp="3nuasqhwwinp6">
                <span className="label text-olive" data-id="element-838" data-mp="1h2t47tyqb4yo">
                  {e.day} {e.date.split(' ')[1]}
                </span>
                <span data-id="element-839" data-mp="1c4hwborzv4j3">
                  <span className="block font-display text-[28px] font-300 leading-tight text-ink decoration-olive decoration-1 underline-offset-[7px] group-hover:underline" data-id="element-840" data-mp="1c2x2k1di7pma">
                    {e.name}
                  </span>
                  <span className="mt-1.5 block text-[13.5px] text-muted" data-id="element-841" data-mp="2cf2fut0t7cak">
                    {e.place} · {e.time}
                  </span>
                </span>
                <span className="flex items-center gap-5 sm:justify-end" data-id="element-842" data-mp="2mc76b51ottx6">
                  <span className="text-[13px] text-muted" data-id="element-843" data-mp="2qdakzo801jwt">Ages {e.ages}</span>
                  <span className="label text-ink" data-id="element-844" data-mp="2vbu4lhz4ejm0">{e.cost}</span>
                </span>
              </Link>
            </li>)}
        </ul>
        <p className="mt-8 text-[14px] text-muted" data-id="element-845" data-mp="303vcyst63q6r">
          Hosting something?{' '}
          <Link to="/events" className="text-ink underline decoration-olive underline-offset-4" data-id="element-846" data-mp="350lsnf128jrn">
            Submit your local event
          </Link>{' '}
          — free, always.
        </p>
      </div>
    </section>;
}
function StartHere() {
  return <section aria-labelledby="start-h" className="border-t border-line bg-white" data-id="element-847" data-mp="12f008efpz729">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-848" data-mp="12cvnr83r8zqd">
        <div id="start-h" data-id="element-849" data-mp="ycldvkcudp68">
          <SectionHead label="New here, or new to town" title="Start with these" action={{
          label: 'All guides',
          to: '/things-to-do'
        }} data-id="element-850" data-mp="yfhclawikhvq" />
        </div>
        <div className="mt-16 grid gap-16 lg:grid-cols-12" data-id="element-851" data-mp="ohbgxb1aw7zb">
          <div className="lg:col-span-7" data-id="element-852" data-mp="1m1xo8njwo3a4">
            <GuideCard guide={featuredGuide} featured data-id="element-853" data-mp="1m4s8of2x5o3j" />
          </div>
          <div className="grid gap-14 lg:col-span-5" data-id="element-854" data-mp="1h4ebxt6rq0kt">
            {guides.slice(0, 2).map(g => <GuideCard key={g.slug} guide={g} data-id="element-855" data-mp="1cbl6t47e0q87" />)}
          </div>
        </div>
      </div>
    </section>;
}
function Spotlight() {
  return <section aria-labelledby="spotlight-h" className="bg-creme/70" data-id="element-856" data-mp="24tywggikl5w7">
      <div className="mx-auto grid max-w-shell items-center gap-16 px-6 py-24 lg:grid-cols-[0.8fr_1.2fr] lg:px-10 lg:py-28" data-id="element-857" data-mp="24v9zuf83sbms">
        <img src={featuredBusiness.image} alt={featuredBusiness.imageAlt} className="photo-soft aspect-[4/5] w-full object-cover" data-id="element-858" data-mp="3ua2ias65t7tf" />
        <div data-id="element-859" data-mp="28mhk41387vm">
          <p className="label text-olive" data-id="element-860" data-mp="3kkssxk2pa390">{featuredBusiness.eyebrow}</p>
          <h2 id="spotlight-h" className="mt-6 max-w-xl font-display text-[42px] font-300 italic leading-[1.04] text-ink sm:text-[52px]" data-id="element-861" data-mp="3kioon10w3287">
            {featuredBusiness.headline}
          </h2>
          <p className="mt-7 max-w-xl text-[16px] leading-[1.85] text-ink/70" data-id="element-862" data-mp="3flg44ts9qm3s">
            {featuredBusiness.body}
          </p>
          <p className="label mt-7 text-muted" data-id="element-863" data-mp="31mykp89ebvro">
            With {featuredBusiness.name}, local author & new mom
          </p>
          <Link to="/place" className="label mt-10 inline-block border border-ink/30 px-8 py-4 text-ink transition-colors duration-150 ease-soft hover:border-ink hover:bg-ink hover:text-paper" data-id="element-864" data-mp="36ljiz25385dh">
            {featuredBusiness.cta}
          </Link>
        </div>
      </div>
    </section>;
}
function Edit() {
  return <section aria-labelledby="edit-h" className="bg-paper" data-id="element-865" data-mp="19z0jt5w2iegn">
      <div className="mx-auto grid max-w-shell items-center gap-16 px-6 py-24 lg:grid-cols-2 lg:px-10 lg:py-28" data-id="element-866" data-mp="19we2wfnaemlr">
        <div data-id="element-867" data-mp="1iz6tshsk4wb2">
          <p className="label text-olive" data-id="element-868" data-mp="1izf6o9ook1m9">Affiliate picks, no sponsorships</p>
          <h2 id="edit-h" className="mt-6 font-display text-[42px] font-300 leading-[1.02] text-ink sm:text-[52px]" data-id="element-869" data-mp="1ixc5cti2um28">
            The SB Family Edit
          </h2>
          <p className="mt-6 max-w-md text-[15.5px] leading-[1.8] text-muted" data-id="element-870" data-mp="1srcininiixm1">
            The handful of things we actually own and re-buy. If it isn’t in our
            own trunk, it isn’t on this list.
          </p>
          <ul className="mt-12 border-t border-line" data-id="element-871" data-mp="cagnir47exe1">
            {familyEdit.map(item => <li key={item.name} className="flex items-baseline justify-between gap-8 border-b border-line py-5" data-id="element-872" data-mp="89ely3mte98w">
                <span data-id="element-873" data-mp="wttdp1fi2d02">
                  <span className="block font-display text-[23px] font-300 text-ink" data-id="element-874" data-mp="11t6aof0350gd">
                    {item.name}
                  </span>
                  <span className="mt-1 block text-[13px] text-muted" data-id="element-875" data-mp="16kxr3wpj1pss">
                    {item.note}
                  </span>
                </span>
                <span className="label shrink-0 text-muted" data-id="element-876" data-mp="1anauwfkprdmx">{item.price}</span>
              </li>)}
          </ul>
          <Link to="/about" className="label mt-10 inline-block bg-ink px-8 py-4 text-paper transition-colors duration-150 ease-soft hover:bg-olive" data-id="element-877" data-mp="itsa3e7uorgw">
            Shop the full edit
          </Link>
        </div>
        <img src={editImage} alt="Flat lay on sand of a canvas tote, striped towel, straw hat, bucket and shovel, sunscreen and a paperback" className="photo-soft aspect-[4/3] w-full object-cover" data-id="element-878" data-mp="rw9ynzaz9w72" />
      </div>
    </section>;
}
function Newsletter() {
  return <section id="newsletter" aria-labelledby="news-h" className="bg-opal/45" data-id="element-879" data-mp="2ddan5tuj807a">
      <div className="mx-auto max-w-shell px-6 py-24 text-center lg:px-10 lg:py-32" data-id="element-880" data-mp="28gagphtrsvfn">
        <p className="label text-ink/60" data-id="element-881" data-mp="23n7ll59chdxc">Sundays, 7am</p>
        <h2 id="news-h" className="mx-auto mt-7 max-w-2xl font-display text-[42px] font-300 leading-[1.05] text-ink sm:text-[56px]" data-id="element-882" data-mp="23lwm3hmxmsc1">
          One short note, every Sunday morning
        </h2>
        <p className="mx-auto mt-7 max-w-md text-[15.5px] leading-[1.8] text-ink/70" data-id="element-883" data-mp="1pnyj18e2aibu">
          What’s open, what’s free, and the one thing worth driving for. Read by
          6,200 local parents.
        </p>
        <form onSubmit={e => e.preventDefault()} className="mx-auto mt-12 flex max-w-md flex-col gap-4 sm:flex-row" data-id="element-884" data-mp="1gol7892gthny">
          <label htmlFor="newsletter-email" className="sr-only" data-id="element-885" data-mp="3f1bpp49ncig4">
            Email address
          </label>
          <input id="newsletter-email" type="email" required autoComplete="email" placeholder="you@email.com" className="min-w-0 flex-1 border-b border-ink/30 bg-transparent py-3 text-center text-[15px] text-ink placeholder:text-ink/40 focus:border-ink focus:outline-none sm:text-left" data-id="element-886" data-mp="3azzy4t77pn5a" />
          <button type="submit" className="label shrink-0 bg-ink px-8 py-4 text-paper transition-colors duration-150 ease-soft hover:bg-olive" data-id="element-887" data-mp="ho7jmpu5klnk">
            Sign me up
          </button>
        </form>
      </div>
    </section>;
}